export default {
  paginaAtual: 1,
  estaCarregando: false,
  todosItensCarregados: false,
  totalItens: null,
  lista: [],
  itemId: null,
  item: {}
}
